import { getEmailAddressForSetTimeProfileService } from '../utils/getEmailAddressForSetTimeProfileService';
import { setTimeProfileService, SetTimeProfileServiceRequest } from 'owa-timeprofile-service';

/**
 * Makes a call to server to disable Merged View for Availability settings
 */
export default async function disableMergedViewAvailabilitySetting(
    mergedViewEnabledAccountSmtpAddress: string
) {
    const consumerEmailAddress = getEmailAddressForSetTimeProfileService(
        mergedViewEnabledAccountSmtpAddress
    );

    let disableRequest: SetTimeProfileServiceRequest = {
        TimeProfileInformation: {
            ConsumerEmailAddress: consumerEmailAddress,
            ConsumerId: '-1',
            MergedViewEnabled: false,
        },
        ConsumerHash: 'abc',
    };

    return await setTimeProfileService(disableRequest);
}
